 <div class="seIconTextPanel {{bemModifierClasses()}}" >  
  <mat-icon class="material-icons-outlined seIconTextPanel__icon">
    {{iconName}}
  </mat-icon>

  <span class="seIconTextPanel__text">{{inputText}}</span>
</div>


